import React from 'react';
import { useHistory } from 'react-router-dom';

import Dialog from '@mui/material/Dialog';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';
import Button from '@mui/material/Button';

import { dialogNoPinContainer } from './styles';

interface DialogNoPinProps {
  open: boolean;
  onClose: () => void;
}

const DialogNoPin = ({ open, onClose }: DialogNoPinProps) => {
  const { push } = useHistory();

  return (
    <Dialog open={open} className={dialogNoPinContainer}>
      <DialogTitle />
      <DialogContent>
        <div className='dialog-content'>
          Password Anda belum berbentuk PIN silahkan lakukan pendaftaran dengan{' '}
          <br />
          menghubungkan nomor handphone anda.
        </div>

        <Button
          onClick={() => {
            onClose();
            push('/grab_account_link');
          }}
          variant='contained'
          color='primary'
          fullWidth
        >
          Hubungkan Sekarang
        </Button>
      </DialogContent>
    </Dialog>
  );
};

export default DialogNoPin;
